/* eslint-disable no-restricted-globals */

const workercode = () => {
  let timerInterval;
  let time = 0;
  self.onmessage = function ({ data: { turn, seconds } }) {
    if (turn === 'off' || timerInterval) {
      clearInterval(timerInterval);
      time = 0;
    }
    if (turn === 'on') {
      if (seconds) {
        time = Number(seconds);
      }
      timerInterval = setInterval(() => {
        time -= 1;
        self.postMessage({ time });
      }, 1000);
    }
  };
};

let code = workercode.toString();
code = code.substring(code.indexOf('{') + 1, code.lastIndexOf('}'));

const blob = new Blob([code], { type: 'application/javascript' });

export default URL.createObjectURL(blob);
